import { Injectable } from '@angular/core';
import { User } from 'BaseDataTypes';

@Injectable({
  providedIn: 'root',
})
export class TransformService {
  constructor() {}
  /**
   * Transforms an array of items by applying a transformation function to each item.
   * The transformation function returns a partial object which is merged with the original item.
   *
   * @template T - The type of elements in the input array.
   * @param {T[]} items - The input array of items.
   * @param {(item: T) => Partial<T>} transform - A function that takes an item and returns a partial object with the transformations.
   * @returns {T[]} - An array of transformed items.
   */
  transformItems<T>(items: T[], transform: (item: T) => Partial<T>): T[] {
    return items.map((item) => ({ ...item, ...transform(item) }));
  }

  /**
   * Transforms the name of a user based on their ID.
   * If the user's ID is 0, the name is set to '(Blank)'; otherwise, the original name is retained.
   *
   * @param {User} user - The user object to transform.
   * @returns {Partial<User>} - A partial user object with the transformed name.
   */
  transformUserName(user: User): Partial<User> {
    return {
      name: user.id === 0 ? '(Blank)' : user.name,
    };
  }
}
